import { createSettingsListApi } from './settings-list-api.factory';

export const recordTypesApi = createSettingsListApi('/record-types');
